module.exports = __webpack_public_path__ + "static/media/DSC_0078.8bc3f51e.jpg";